import styled from 'vue-styled-components'

export const Content = styled.div`
    > section {
        display: flex;
        padding-bottom: 2rem;
        align-items: flex-start;
        flex-direction: column;

        > label {
            margin-bottom: 0.3rem;
            color: ${props => props.theme?.text_site_color ?? '#4a505e'};
            font: 600 1.5rem/1.1 ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif;
            letter-spacing: .005em;
            text-transform: capitalize;
            display: inline-block;

            .color-selected {
                font-weight: 300;
                text-transform: initial;
            }
        }

        > ul {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 0;

            li {
                transition: all .2s linear;
                padding: 4px 10px;
                border: 1px solid ${props => props.theme?.products?.grid?.size?.border_color ?? '#dfdfdf'};
                background: ${props => props.theme?.products?.grid?.size?.background_color ?? '#fff'};
                margin-right: 3px;
                margin-bottom: 0.3rem;
                cursor: pointer;
                border-radius: ${props => props.theme?.products?.grid?.size?.border_radius ?? '0'};

                span {
                    color: ${props => props.theme?.products?.grid?.size?.color ?? '#000'};
                    transition: all .2s linear;
                }

                &.active,
                &:hover {
                    border: 1px solid ${props => props.theme?.products?.grid?.size?.border_color_active ?? '#000'};
                    background: ${props => props.theme?.products?.grid?.size?.background_color_active ?? '#fff'};

                    span {
                        color: ${props => props.theme?.products?.grid?.size?.color_active ?? '#000'};
                    }
                }

                &.active {
                    pointer-events: none;
                }

                &.disabled-item-grid {
                    pointer-events: none;
                    border: 1px solid red;

                    span {
                        text-decoration: line-through red;
                        opacity: 0.7;
                    }
                }

                &.item-grid-color {
                    display: inline-flex;
                    margin-right: 0.4rem;
                    width: 3.8rem;
                    height: 3.8rem;
                    border-radius: 50%;
                    padding: 0.1rem;
                    border: 1px solid transparent;

                    &:hover {
                        border: 1px solid ${props => props.theme?.products?.grid?.color?.border_color_active ?? '#000'};
                    }
                }

                &.active.item-grid-color {
                    border: 1px solid ${props => props.theme?.products?.grid?.color?.border_color_active ?? '#000'};
                    pointer-events: none;
                }

                &.disabled-item-grid.item-grid-color {
                    pointer-events: none;
                    position: relative;
                    padding: 0;
                    border: 1px solid red;
                    &:after {
                        content: "";
                        position: absolute;
                        top: 0;
                        left: 17px;
                        width: 1px;
                        height: 37px;
                        background-color: red;
                        z-index: 9;
                        transform: rotate(-45deg);
                    }
                }
            }
        }
    }

    > .required {
        padding-bottom: 1.5rem;
        margin-top: -1.5rem;
    }
`